module.exports = __webpack_public_path__ + "img/tik.5986b7e4.svg";